import { useSelector } from "react-redux";
import {
  getSiteFavIcon,
  getSiteLogoLight,
  getSiteLogoDark,
  getSiteName,
  getSiteTitle,
  getSiteDescription,
  getSettingValue,
  getCompanyAddress,
  getCompanyPhone,
  getCompanyEmail,
  getCurrencySymbol,
  getCurrencyCode,
  getOrderIdPrefix,
  getProductCodePrefix,
  getCustomerPrefix,
  getFixedDeliveryCharge,
  getIsFreeDelivery,
  getMinimumItemPrice,
  getFilesBaseUrl,
  getCompanyVatRegistration,
} from "../api/settingsService";

export const useSettings = () => {
  const settingsData = useSelector((state) => state.settingsData);

  const settings = settingsData?.settings;
  const loading = settingsData?.loading;
  const error = settingsData?.error;

  return {
    // Raw settings data
    settings,
    loading,
    error,

    // Common getters
    favIcon: getSiteFavIcon(settings),
    logoLight: getSiteLogoLight(settings),
    logoDark: getSiteLogoDark(settings),
    siteName: getSiteName(settings),
    siteTitle: getSiteTitle(settings),
    description: getSiteDescription(settings),
    companyAddress: getCompanyAddress(settings),
    companyPhone: getCompanyPhone(settings),
    companyEmail: getCompanyEmail(settings),
    currencySymbol: getCurrencySymbol(settings),
    currencyCode: getCurrencyCode(settings),
    orderIdPrefix: getOrderIdPrefix(settings),
    productCodePrefix: getProductCodePrefix(settings),
    customerPrefix: getCustomerPrefix(settings),
    fixedDeliveryCharge: getFixedDeliveryCharge(settings),
    isFreeDelivery: getIsFreeDelivery(settings),
    minimumItemPrice: getMinimumItemPrice(settings),
    filesBaseUrl: getFilesBaseUrl(settings),
    companyVatRegistration: getCompanyVatRegistration(settings),

    // Utility function to get any setting value
    getValue: (key, defaultValue) =>
      getSettingValue(settings, key, defaultValue),

    // Check if settings are loaded
    isLoaded: !loading && !error && settings !== null,

    // Check if there's an error
    hasError: !!error,
  };
};
